import React, { FC, useState } from 'react';

import Loader from 'components/Loader';
import useStyles from './styles';

interface IProps {
  url: string;
  title?: string;
}

const RewestIframe: React.FC<IProps> = ({ url, title = 'Rewest Form' }) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  if (!url) {
    return <div>Rewest form URL not provided</div>;
  }

  return (
    <div className={classes.container}>
      {isLoading && (
        <div className={classes.loaderContainer}>
          <Loader />
        </div>
      )}
      <iframe
        src={url}
        className={classes.iframe}
        title={title}
        sandbox="allow-scripts allow-forms allow-popups allow-top-navigation allow-same-origin"
        onLoad={handleIframeLoad}
      />
    </div>
  );
};

export default RewestIframe;
